import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { PICKUP_OPTIMYZER_STEP } from "../constants";

const StepperButtons = (
  step,
  classes,
  selectedPickupsList,
  driverRecommendedPickupSelected,
  unassignPickupSelected,
  pickupUpdateInProgress,
  notifyInProgress,
  handleNext,
  optymize,
  acceptNotify,
  onClose,
  unassignPickupDropdownError
) => {
  let isAcceptAndNotifyDisabled = false;
  if (step === PICKUP_OPTIMYZER_STEP.REVIEW_OPTIMIZED_SOLUTION) {
    isAcceptAndNotifyDisabled = (
      driverRecommendedPickupSelected.length + unassignPickupSelected.length === 0 ||
      Object.values(unassignPickupDropdownError).filter(Boolean).length
    );
  }
  switch (step) {
    case PICKUP_OPTIMYZER_STEP.CORRECT_PICKUP_INFO:
      return (
        <Button
          variant="contained"
          disabled={selectedPickupsList.length === 0}
          color="primary"
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          onClick={handleNext}
        >
          Next
        </Button>
      );
    case PICKUP_OPTIMYZER_STEP.SELECT_DRIVERS:
      return (
        <Button
          variant="contained"
          disabled={pickupUpdateInProgress}
          color="primary"
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          id="optymizebtn"
          onClick={optymize}
        >
          {pickupUpdateInProgress ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            "Optymize"
          )}
        </Button>
      );
    case PICKUP_OPTIMYZER_STEP.REVIEW_OPTIMIZED_SOLUTION:
      return (
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          disabled={isAcceptAndNotifyDisabled}
          onClick={acceptNotify}
        >
          {notifyInProgress ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            "Accept and Notify Drivers"
          )}
        </Button>
      );
    case PICKUP_OPTIMYZER_STEP.RESULTS:
      return (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClose}
        >
          Done
        </Button>
      );
  }
};

export default StepperButtons;
